export default __webpack_public_path__ + "static/media/signin.e09f879e.jpg";